import coqueImg from "../../images/coque.jpg";
import light from "../../images/icons/light.png";
import ref from "../../images/icons/ref.png";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../ui/carousel";

const MissionServiceAvizeau = () => {
  const images = [
    { id: 1, img: coqueImg },
    { id: 2, img: coqueImg },
  ];

  return (
    <div>
      <div className="container px-4 mx-auto mt-10 mb-10 sm:px-6 lg:px-8">
        <h1 className="text-xl font-bold text-center text-primary">
          Un réseau historique, une modernisation continue
        </h1>
        <p className="mt-5 text-base text-center text-primary">
          Hérité de l'époque de Versailles au XVIIe siècle, notre réseau
          d'assainissement est aujourd'hui inspecté et rénové grâce aux
          technologies les plus modernes, alliant ainsi patrimoine historique et
          innovation technique.
        </p>

        <div className="py-6 bg-white sm:py-8">
          <div className="max-w-6xl px-4 mx-auto">
            <h2 className="mb-6 text-xl font-bold text-center text-black">
              On distingue deux types de travaux
            </h2>
            <div className="flex flex-col gap-6 md:flex-row">
              {/* Card 1: Renouvellement */}
              <div className="flex-1 p-4 bg-white border border-gray-200 rounded-lg shadow-lg sm:p-6">
                <div className="flex items-center justify-start mb-4">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full sm:w-16 sm:h-16 bg-secondary/15">
                    <div
                      className="w-8 h-8 sm:w-10 sm:h-10 bg-primary"
                      style={{
                        mask: `url(${ref}) no-repeat center`,
                        maskSize: "contain",
                        WebkitMask: `url(${ref}) no-repeat center`,
                        WebkitMaskSize: "contain",
                      }}
                    />
                  </div>
                </div>
                <h3 className="text-base font-semibold text-black text-start">
                  Renouvellement
                </h3>
                <p className="mb-4 text-sm text-gray-700 text-start">
                  Pose d’un nouveau réseau avec un tracé optimisé, utilisant des
                  matériaux durables et des techniques d’installation minimisant
                  l’impact sur l’environnement et la circulation.
                </p>
                <hr />
                <div className="mt-2 text-start">
                  <p className="text-base text-primary">
                    15 chantiers en cours
                  </p>
                </div>
              </div>

              {/* Card 2: Réhabilitation */}
              <div className="flex-1 p-4 bg-white border border-gray-200 rounded-lg shadow-lg sm:p-6">
                <div className="flex items-center justify-start mb-4">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full sm:w-16 sm:h-16 bg-secondary/15">
                    <div
                      className="w-8 h-8 sm:w-10 sm:h-10 bg-primary"
                      style={{
                        mask: `url(${light}) no-repeat center`,
                        maskSize: "contain",
                        WebkitMask: `url(${light}) no-repeat center`,
                        WebkitMaskSize: "contain",
                      }}
                    />
                  </div>
                </div>
                <h3 className="text-base font-semibold text-black text-start">
                  Réhabilitation
                </h3>
                <p className="mb-4 text-sm text-gray-700 text-start">
                  Travaux internes pour restaurer les tuyaux existants grâce à
                  des techniques sans tranchée comme le chemisage, préservant
                  ainsi le patrimoine tout en garantissant la performance.
                </p>
                <hr />
                <div className="mt-2 text-start">
                  <p className="text-base text-primary">
                    45 km réhabilités depuis 2020
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="py-6 sm:py-8 bg-[#E8F5F1]">
        <div className="max-w-4xl px-4 mx-auto">
          <h2 className="mb-6 text-xl font-bold text-center text-black">
            Nos objectifs prioritaires
          </h2>
          <div className="flex flex-col justify-center gap-6 md:flex-row">
            {/* Card 1: Maintien de l’écoulement */}
            <div className="flex-1 p-4 text-center bg-white border border-gray-200 rounded-lg shadow-sm sm:p-6">
              <div className="mx-auto mb-4 text-2xl sm:text-3xl">💧</div>
              <h3 className="mb-2 text-base font-semibold text-black whitespace-nowrap">
                Maintien de l’écoulement
              </h3>
              <p className="text-base text-gray-700">
                Garantir un service continu et efficace pour tous les usagers du
                territoire
              </p>
            </div>

            {/* Card 2: Protection du sol et des nappes */}
            <div className="flex-1 p-4 text-center bg-white border border-gray-200 rounded-lg shadow-sm sm:p-6">
              <div className="mx-auto mb-4 text-2xl sm:text-3xl">🌍</div>
              <h3 className="mb-2 text-base font-semibold text-black whitespace-nowrap">
                Protection du sol et des nappes
              </h3>
              <p className="text-base text-gray-700">
                Garantir un service continu et efficace pour tous les usagers du
                territoire
              </p>
            </div>

            {/* Card 3: Prévention des affaissements */}
            <div className="flex-1 p-4 text-center bg-white border border-gray-200 rounded-lg shadow-sm sm:p-6">
              <div className="mx-auto mb-4 text-2xl sm:text-3xl">🏗️</div>
              <h3 className="mb-2 text-base font-semibold text-black whitespace-nowrap">
                Prévention des affaissements
              </h3>
              <p className="text-base text-gray-700">
                Sécuriser les infrastructures urbaines et prévenir les risques
                d’effondrement
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="container px-4 mx-auto mt-10 mb-10 sm:px-6 lg:px-8">
        <div className="max-w-6xl px-4 mx-auto">
          <Carousel opts={{ align: "start", loop: true }} className="w-full">
            <CarouselContent>
              {images.map((item) => (
                <CarouselItem key={item.id}>
                  <div className="flex items-center justify-center w-full h-64 bg-gray-200 rounded-lg sm:h-80 md:h-96">
                    <img
                      src={item.img}
                      alt="Réseau d'assainissement"
                      className="object-cover w-full h-full rounded-lg"
                    />
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="absolute flex items-center justify-center  border-none  text-white transform -translate-y-1/2 bg-teal-500 rounded-full   left-2 sm:left-4 top-1/2 hover:bg-teal-600" />
            <CarouselNext className="absolute flex items-center justify-center border-none text-white transform -translate-y-1/2 bg-teal-500 rounded-full   right-2 sm:right-4 top-1/2 hover:bg-teal-600" />
          </Carousel>
        </div>
      </div>
    </div>
  );
};

export default MissionServiceAvizeau;
